import { activeCommentAtom } from "@app/shared/atoms/comments-atom";
import { useIsLoggedIn } from "@framework/account/hooks";
import { useEffect } from "react";
import { useComments } from "./use-comments";

export function useCommentsPanel(typeId: number, type: string) {
  const { loadComments, ...comments } = useComments(typeId, type);
  const activeComment = activeCommentAtom.useValue();
  const isLoggedIn = useIsLoggedIn();

  useEffect(() => {
    loadComments();
  }, [loadComments]);

  return {
    ...comments,
    isEditing: Boolean(activeComment),
    isLoggedIn,
    loadComments,
  };
}
